import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { queryClient } from 'constants/query-client';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { PurchaseHistory } from './useGetPaymentHistory';

export type PurchaseHistoryDetails = Object & { status: string };

export const useGetPurchaseHistoryStatus = (
  id: number,
  options: Partial<
    UseMutationOptions<PurchaseHistoryDetails, AxiosError<ApiError>>
  > = {}
) =>
  useMutation({
    mutationFn: async (): Promise<PurchaseHistoryDetails> => {
      const { data } = await api.post<ApiResponse<PurchaseHistoryDetails>>(
        `/purchase/history/status/${id}`
      );

      return data.data;
    },
    mutationKey: ['purchase/history/status', id],
    onSuccess: (result) => {
      queryClient.setQueryData<PurchaseHistory[]>(
        ['purchase/history'],
        (data) => {
          return data?.map((d) =>
            d.id === id ? { ...d, status: result.status } : d
          );
        }
      );
    },

    ...options,
  });
